import {
  Benefit,
  OverlappingEmpForm,
} from '~/features/OverlappingEmploymentDialog/hooks/useOverlappingEmploymentForm';
import {
  BenefitSubmitData,
  submitBenefitProposal,
} from '~/scenes/RewardingModule/components/EmployeeProposalsDialog/components/EmployeeProposal/components/Forms/BenefitProposalForm/data';

const mapOverlappingFormToBenefitProposalPayload = (
  employmentId: number,
  benefit: Benefit,
  loginId: number,
  isHR: boolean,
): BenefitSubmitData | FormData => {
  const {
    fBenefitProposalAmount,
    fBenefitProposalTaxableAmount,
    fEmplAttachment,
    ...benefitRest
  } = benefit;

  const payloadCommon: Omit<BenefitSubmitData, 'fEmplAttachment'> = {
    ...benefitRest,
    fEmplId: employmentId,
    fBenefitProposalAmount: fBenefitProposalAmount?.toString() ?? '',
    fBenefitProposalTaxableAmount:
      fBenefitProposalTaxableAmount?.toString() ?? '',
    fBenefitProposalStatus: isHR ? 'HR_APPROVED' : 'PROPOSED',
    fBenefitProposalHrId: isHR ? loginId : -1,
    fBenefitProposalManagerId: isHR ? -1 : loginId,
    fBenefitProposalHigherMgrId: '-1',
  };

  // JSON Payload
  if (!fEmplAttachment) {
    return {
      ...payloadCommon,
      fEmplAttachment: {
        fAttachmentId: -1,
        fAttachmentName: '',
      },
    };
  }

  // FormData payload
  const formData = new FormData();
  if (fEmplAttachment) {
    Object.entries(payloadCommon).forEach((sbData) => {
      if (sbData[1] !== null && sbData[1] !== undefined) {
        formData.append(
          sbData[0],
          typeof sbData[1] === 'string' ? sbData[1] : sbData[1].toString(),
        );
      }
    });
    formData.append('file', fEmplAttachment);
    formData.append('fEmplAttachment.fAttachmentName', fEmplAttachment.name);
  }

  return formData;
};

export const saveBenefitProposal = async (
  employeeId: number,
  employmentId: number,
  form: OverlappingEmpForm,
  loginId: number,
  isHR: boolean,
) => {
  Promise.all(
    form.overlappingEmployment.benefit.map((benefit) => {
      return submitBenefitProposal(
        mapOverlappingFormToBenefitProposalPayload(
          employmentId,
          benefit,
          loginId,
          isHR,
        ),
        { employeeId, employmentId },
      ).catch((e) => {
        console.log('saveBenefitProposal', e);
      });
    }),
  );
};
